<template>
  <div class="file-att-wrap"
       style="border: 2px dotted #e0e0e0">
    <div class="file-att-con">
      <button class="btn-file-att"
              @click="upload_click">
        <span>파일첨부</span>
      </button>
      <div class="entry-txt">
<!--        여기로 <span class="pc01">파일을 끌어놓거나</span> -->[파일첨부] <span class="pc01">버튼을 클릭</span>하세요.<br>
        (파일 첨부는 {{maxCnt}}개까지 가능하며, 최대 {{ maxSize }}MB까지 가능합니다.)
      </div>
    </div>
    <div class="file-att-list mgt15">
      <ul>
        <li v-for="({se, index, flnm, fileMg, extsnNm}) in tcfls"
            :key="'file_' + index">
          <a href="javascript:;">
            <div class="img-com"
                 :class="$file.getExtsnClassByExtsn(extsnNm)">
              <span>{{ extsnNm }}</span>
            </div>
            <span class="pdl10">
              {{ flnm + ' [ ' + $file.getFileSize(fileMg) + ' ]' }}
            </span>
          </a>
          <button class="mgl0"
                  @click="dlt_click(se, index)">
            <div class="img-com __del01 mgl10">
              <span>삭제</span>
            </div>
          </button>
        </li>
      </ul>
    </div>
  </div>
  <p class="mgt10"
     style="text-align: right;font-size: 13px;font-family: 'NotoKrR';font-weight: bold">
  </p>
  <input ref="elFile"
         type="file"
         style="display: none;"
         multiple="multiple"
         :accept="accepts"
         @change="file_change">
</template>

<script setup>
import {defineProps, defineEmits, onMounted, ref, computed} from 'vue';
import {getStore, getUtils} from "@/utils/import";
const {$file, $valid, $alert, $cmmn} = getUtils();
const {$loading} = getStore();

const props = defineProps({
  se: {
    type: String,
    default: 'tmp',
  },
  files: {
    type: Array,
    default: () => []
  },
  accepts: {
    type: String,
    default: 'gif,png,jpg,jpeg,bmp,doc,docx,xls,xlsx,ppt,pptx,hwp,pdf,zip'
  },
  maxCnt: {
    type: Number,
    default: 2
  },
  maxSize: {
    type: Number,
    default: 10
  },
  isResizeImg: { /* 업로드시 이미지 리사이즈 처리 여부 */
    type: Boolean,
    default: false,
  },
  imgMaxSize: { /* 조절가능 사이즈: 720, 1080 */
    type: Number,
    default: 720,
    validator(value) {
      return value == 720 || value == 1080;
    }
  }
});

const emits = defineEmits(['change', 'delete']);

const oldTcfls = ref([]);
const dltTcfls = ref([]);
const newTcfls = ref([]);

const tcfls = computed(() => {
  let allFiles = [];
  if (props.files) {
    allFiles = props.files.map((file, index) => {
      return {
        se: 'old',
        index,
        flnm: file.orgnFlnm,
        fileMg: file.fileMg,
        extsnNm: file.extsnNm,
      }
    });
  }

  allFiles = allFiles.concat(newTcfls.value.map((file, index) => {
    return {
      se: 'new',
      index,
      flnm: file.orgnFlnm,
      fileMg: file.fileMg,
      extsnNm: file.extsnNm,
    }
  }));

  return allFiles;
});

const elFile = ref(null);
const upload_click  = () => {
  elFile.value.click();
}

const file_change = async () => {
  try {
    $loading.on();

    const {files: uploads} = elFile.value;
    const currentCount = tcfls.value.length;
    const remainingSlots = props.maxCnt - currentCount;

    let uploadList = Array.from(uploads).slice(0, remainingSlots);

    // 1. maxcount 확인
    if (uploadList.length < uploads.length) {
      $alert('최대 ' + props.maxCnt + '개까지 첨부 가능합니다.');
      return false;
    }

    const maxFileSize = props.maxSize * 1024 * 1024;

    let extsnNotValidCnt = 0;
    let maxSizeValidCnt = 0;

    for (const file of uploads) {
      const extsn = $file.getExtsnByFileNm(file.name);
      const isValidExtsn = $valid.fileExtsn(extsn, props.accepts);

      if (!isValidExtsn) extsnNotValidCnt += 1;
      if (file.size > maxFileSize) maxSizeValidCnt += 1;

      file.extsn = extsn;
    }

    // 2. 확장자 확인
    if (extsnNotValidCnt > 0) {
      $alert('업로드 가능한 확장자가 아닙니다.')
      return false;
    }

    // 3. 파일 사이즈
    if (maxSizeValidCnt > 0) {
      $alert('업로드 가능한 최대 파일 크기는 ' + props.maxSize + 'MB입니다.');
      return false;
    }

    const se = props.se;
    const options = {
      imgResize: {
        is: false,
        maxSize: 720,
      }
    }
    if (props.isResizeImg) {
      options.imgResize.is = true;
      options.imgResize.maxSize = props.imgMaxSize;
    }
    const fileInfos = await $file.ncp[se].uplds(uploads, options);

    newTcfls.value = newTcfls.value.concat(fileInfos);
    emits('change', fileInfos);
    elFile.value.value = '';

  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const dlt_click = async (se, index) => {
  try {
    $loading.on();

    let dltFiles = oldTcfls.value;
    if (se == 'new') {
      dltFiles = newTcfls.value;
    } else if (se == 'old') {
      dltTcfls.value = JSON.parse(JSON.stringify(oldTcfls.value[index]));
    }

    dltFiles.splice(index, 1);

    emits('delete', {se, index});
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

onMounted(() => {
  if (props.files) {
    oldTcfls.value = JSON.parse(JSON.stringify(props.files));
  }
})
</script>

<style scoped>

</style>
